import { EProvince, PROVINCES } from './ccaa';

export enum ELegalIdType {
  DNI_NIF_NIE = 'DNI_NIF_NIE',
  PASSPORT_OTHER = 'PASSPORT_OTHER'
}

export enum EGender {
  MALE = 'MALE',
  FEMALE = 'FEMALE'
}

export const LEGAL_ID_TYPES = Object.values(ELegalIdType);
export const GENDERS = Object.values(EGender);

export enum EStreetType {
  AQUEDUCT = 'AQUEDUCT',
  AERODROME = 'AERODROME',
  AIRPORT = 'AIRPORT',
  PROMENADE = 'PROMENADE', 
  WAREHOUSE = 'WAREHOUSE',
  HEIGHT = 'HEIGHT',
  PO_BOX = 'PO_BOX',
  APARTMENT = 'APARTMENT',
  STREAM = 'STREAM',
  HIGHWAY = 'HIGHWAY',
  AVENUE = 'AVENUE',
  DESCENT = 'DESCENT',
  RAVINE = 'RAVINE',
  DISTRICT = 'DISTRICT',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  BASILICA = 'BASILICA',
  BLOCK = 'BLOCK',
  BOULEVARD = 'BOULEVARD',
  ST_ABBREV = 'ST_ABBREV',
  STREET = 'STREET',
  NARROW_ALLEY = 'NARROW_ALLEY',
  ALLEY = 'ALLEY',
  PATH = 'PATH',
  CAMP = 'CAMP',
  CANAL = 'CANAL',
  CORNER_STREET = 'CORNER_STREET',
  CATTLE_TRACK = 'CATTLE_TRACK',
  WAY = 'WAY',
  ROAD = 'ROAD',
  LANE = 'LANE',
  HOUSE = 'HOUSE',
  HAMLET = 'HAMLET',
  SHEDS = 'SHEDS',
  BOOTH = 'BOOTH',
  CASTLE = 'CASTLE',
  CEMETERY = 'CEMETERY',
  CENTER = 'CENTER',
  SHOPPING_CENTER = 'SHOPPING_CENTER',
  CULTURAL_CENTER = 'CULTURAL_CENTER',
  PUBLIC_CENTER = 'PUBLIC_CENTER',
  HEALTH_CENTER = 'HEALTH_CENTER',
  HILL = 'HILL',
  CHALET = 'CHALET',
  CITY = 'CITY',
  TRACKWAY = 'TRACKWAY',
  SCHOOL_INSTITUTION = 'SCHOOL_INSTITUTION',
  COLONY = 'COLONY',
  COMPLEX = 'COMPLEX',
  GROUPING = 'GROUPING',
  STEEP_STREET = 'STEEP_STREET',
  SLOPE = 'SLOPE',
  PASTURE = 'PASTURE',
  UNKNOWN = 'UNKNOWN',
  SCATTERED = 'SCATTERED',
  DISPENSARY = 'DISPENSARY',
  BUILDING = 'BUILDING',
  JUNCTION = 'JUNCTION',
  STAIRWAY = 'STAIRWAY',
  SCHOOL = 'SCHOOL',
  OFFICIAL_SCHOOL = 'OFFICIAL_SCHOOL',
  VOCATIONAL_SCHOOL = 'VOCATIONAL_SCHOOL',
  STATION = 'STATION',
  METRO_STATION = 'METRO_STATION',
  STADIUM = 'STADIUM',
  ESPLANADE = 'ESPLANADE',
  OUTSKIRTS = 'OUTSKIRTS',
  FACTORY = 'FACTORY',
  FACULTY = 'FACULTY',
  DISMANTLED_RAILWAY = 'DISMANTLED_RAILWAY',
  ESTATE = 'ESTATE',
  FOUNTAIN = 'FOUNTAIN',
  CHARITABLE_TEACHING_FOUNDATION = 'CHARITABLE_TEACHING_FOUNDATION',
  FOUNDATION = 'FOUNDATION',
  GALLERY = 'GALLERY',
  ROUNDABOUT = 'ROUNDABOUT',
  MAIN_AVENUE = 'MAIN_AVENUE',
  GROUP = 'GROUP',
  HIPPODROME = 'HIPPODROME',
  HOSPITAL = 'HOSPITAL',
  HOTEL = 'HOTEL',
  VOCATIONAL_TRAINING_INSTITUTE = 'VOCATIONAL_TRAINING_INSTITUTE',
  CHURCH = 'CHURCH',
  POLYTECHNIC_INSTITUTE = 'POLYTECHNIC_INSTITUTE',
  INSTITUTE = 'INSTITUTE',
  GARDEN = 'GARDEN',
  LYCEUM = 'LYCEUM',
  PLACE = 'PLACE',
  CITY_BLOCK = 'CITY_BLOCK',
  SLAUGHTERHOUSE = 'SLAUGHTERHOUSE',
  MARKET = 'MARKET',
  MINISTRY = 'MINISTRY',
  MOUNT = 'MOUNT',
  NUCLEUS = 'NUCLEUS',
  PAVILION = 'PAVILION',
  PALACE = 'PALACE',
  SITE = 'SITE',
  PLOT = 'PLOT',
  PARK = 'PARK',
  PRIVATE_STREET = 'PRIVATE_STREET',
  PASSAGEWAY = 'PASSAGEWAY',
  PASSAGE = 'PASSAGE',
  WALKWAY = 'WALKWAY',
  OVERPASS = 'OVERPASS',
  COURTYARD = 'COURTYARD',
  TRUST = 'TRUST',
  TRACK = 'TRACK',
  SQUARE = 'SQUARE',
  SMALL_SQUARE = 'SMALL_SQUARE',
  SETTLEMENT = 'SETTLEMENT',
  SPORTS_CENTER = 'SPORTS_CENTER',
  INDUSTRIAL_ESTATE = 'INDUSTRIAL_ESTATE',
  EXTENSION = 'EXTENSION',
  TOWN = 'TOWN',
  BRIDGE = 'BRIDGE',
  GATE = 'GATE',
  PORT = 'PORT',
  RAMBLA = 'RAMBLA',
  RAMP = 'RAMP',
  RESIDENTIAL = 'RESIDENTIAL',
  NOOK = 'NOOK',
  CORNER_AREA = 'CORNER_AREA',
  RIVER = 'RIVER',
  RING_ROAD = 'RING_ROAD',
  TRAFFIC_CIRCLE = 'TRAFFIC_CIRCLE',
  SACRAMENTAL = 'SACRAMENTAL',
  EXIT = 'EXIT',
  SECTOR = 'SECTOR',
  TRAIL = 'TRAIL',
  HEALTH_SERVICE = 'HEALTH_SERVICE',
  LOCATION = 'LOCATION',
  SUBSTATION = 'SUBSTATION',
  ASCENT = 'ASCENT',
  FUNERAL_HOME = 'FUNERAL_HOME',
  CROSS_STREET = 'CROSS_STREET',
  REAR = 'REAR',
  CROSSING = 'CROSSING',
  HOUSING_ESTATE = 'HOUSING_ESTATE',
  NEIGHBORHOOD_UNIT = 'NEIGHBORHOOD_UNIT',
  SIDEWALK = 'SIDEWALK',
  THOROUGHFARE = 'THOROUGHFARE',
  TRACKS = 'TRACKS',
  ZONE = 'ZONE',
  ZOO = 'ZOO'
}

export const STREET_TYPES = Object.values(EStreetType);

export enum ENationality {
  AFGHAN = 'AFGHAN',
  ALBANIAN = 'ALBANIAN',
  GERMAN = 'GERMAN',
  ANDORRAN = 'ANDORRAN',
  ANGOLAN = 'ANGOLAN',
  ANTIGUAN = 'ANTIGUAN',
  ALGERIAN = 'ALGERIAN',
  ARGENTINIAN = 'ARGENTINIAN',
  ARMENIAN = 'ARMENIAN',
  ARUBAN = 'ARUBAN',
  AUSTRALIAN = 'AUSTRALIAN',
  AUSTRIAN = 'AUSTRIAN',
  AZERBAIJANI = 'AZERBAIJANI',
  BAHAMIAN = 'BAHAMIAN',
  BAHRAINI = 'BAHRAINI',
  BANGLADESHI = 'BANGLADESHI',
  BARBADIAN = 'BARBADIAN',
  BELGIAN = 'BELGIAN',
  BELIZEAN = 'BELIZEAN',
  BENINESE = 'BENINESE',
  BELARUSIAN = 'BELARUSIAN',
  BURMESE = 'BURMESE',
  BOLIVIAN = 'BOLIVIAN',
  BOSNIAN_HERZEGOVINIAN = 'BOSNIAN_HERZEGOVINIAN',
  BOTSWANAN = 'BOTSWANAN',
  BRAZILIAN = 'BRAZILIAN',
  BRITISH = 'BRITISH',
  BRUNEIAN = 'BRUNEIAN',
  BULGARIAN = 'BULGARIAN',
  BURKINABE = 'BURKINABE',
  BURUNDIAN = 'BURUNDIAN',
  BHUTANESE = 'BHUTANESE',
  CAPE_VERDEAN = 'CAPE_VERDEAN',
  CAMBODIAN = 'CAMBODIAN',
  CAMEROONIAN = 'CAMEROONIAN',
  CANADIAN = 'CANADIAN',
  CENTRAL_AFRICAN = 'CENTRAL_AFRICAN',
  CHADIAN = 'CHADIAN',
  CZECH = 'CZECH',
  CHILEAN = 'CHILEAN',
  CHINESE = 'CHINESE',
  CYPRIOT = 'CYPRIOT',
  COLOMBIAN = 'COLOMBIAN',
  COMORAN = 'COMORAN',
  CONGOLESE_CONGO = 'CONGOLESE_CONGO',
  CONGOLESE_DRCONGO = 'CONGOLESE_DRCONGO',
  COSTA_RICAN = 'COSTA_RICAN',
  CROATIAN = 'CROATIAN',
  CUBAN = 'CUBAN',
  CURACAOAN = 'CURACAOAN',
  DANISH = 'DANISH',
  COOK_ISLANDS = 'COOK_ISLANDS',
  NORFOLK_ISLANDS = 'NORFOLK_ISLANDS',
  TOKELAUAN = 'TOKELAUAN',
  UNKNOWN_NATIONALITY = 'UNKNOWN_NATIONALITY',
  DOMINICAN = 'DOMINICAN',
  DOMINICAN_COMMONWEALTH = 'DOMINICAN_COMMONWEALTH',
  EQUATORIAL_GUINEAN = 'EQUATORIAL_GUINEAN',
  ECUADORIAN = 'ECUADORIAN',
  EGYPTIAN = 'EGYPTIAN',
  EMIRATI = 'EMIRATI',
  ERITREAN = 'ERITREAN',
  SLOVAK = 'SLOVAK',
  SLOVENIAN = 'SLOVENIAN',
  SPANISH_NATIONALITY = 'SPANISH_NATIONALITY',
  SRI_LANKAN = 'SRI_LANKAN',
  AMERICAN = 'AMERICAN',
  ESTONIAN = 'ESTONIAN',
  ETHIOPIAN = 'ETHIOPIAN',
  FILIPINO = 'FILIPINO',
  FINNISH = 'FINNISH',
  FIJIAN = 'FIJIAN',
  FRENCH = 'FRENCH',
  GABONESE = 'GABONESE',
  GAMBIAN = 'GAMBIAN',
  GEORGIAN = 'GEORGIAN',
  GHANAIAN = 'GHANAIAN',
  GRENADIAN = 'GRENADIAN',
  GREEK = 'GREEK',
  GUAMANIAN = 'GUAMANIAN',
  GUATEMALAN = 'GUATEMALAN',
  BISSAU_GUINEAN = 'BISSAU_GUINEAN',
  GUINEAN = 'GUINEAN',
  GUYANESE = 'GUYANESE',
  HAITIAN = 'HAITIAN',
  HONDURAN = 'HONDURAN',
  HUNGARIAN = 'HUNGARIAN',
  INDIAN = 'INDIAN',
  INDONESIAN = 'INDONESIAN',
  IRANIAN = 'IRANIAN',
  IRAQI = 'IRAQI',
  IRISH = 'IRISH',
  ICELANDIC = 'ICELANDIC',
  ISRAELI = 'ISRAELI',
  ITALIAN = 'ITALIAN',
  JAMAICAN = 'JAMAICAN',
  JAPANESE = 'JAPANESE',
  JORDANIAN = 'JORDANIAN',
  KAZAKH = 'KAZAKH',
  KENYAN = 'KENYAN',
  KYRGYZ = 'KYRGYZ',
  KIRIBATIAN = 'KIRIBATIAN',
  KUWAITI = 'KUWAITI',
  LAOTIAN = 'LAOTIAN',
  LESOTHOAN = 'LESOTHOAN',
  LATVIAN = 'LATVIAN',
  LEBANESE = 'LEBANESE',
  LIBERIAN = 'LIBERIAN',
  LIBYAN = 'LIBYAN',
  LIECHTENSTEINER = 'LIECHTENSTEINER',
  LITHUANIAN = 'LITHUANIAN',
  LUXEMBOURGER = 'LUXEMBOURGER',
  MACANESE = 'MACANESE',
  MACEDONIAN = 'MACEDONIAN',
  MALAYSIAN = 'MALAYSIAN',
  MALAWIAN = 'MALAWIAN',
  MALDIVIAN = 'MALDIVIAN',
  MALAGASY = 'MALAGASY',
  MALIAN = 'MALIAN',
  MALTESE = 'MALTESE',
  MANX = 'MANX',
  IVORIAN = 'IVORIAN',
  MOROCCAN = 'MOROCCAN',
  MARSHALLESE = 'MARSHALLESE',
  MAURITIAN = 'MAURITIAN',
  MAURITANIAN = 'MAURITANIAN',
  MEXICAN = 'MEXICAN',
  MICRONESIAN = 'MICRONESIAN',
  MOLDOVAN = 'MOLDOVAN',
  MONEGASQUE = 'MONEGASQUE',
  MONGOLIAN = 'MONGOLIAN',
  MONTENEGRIN = 'MONTENEGRIN',
  MOZAMBICAN = 'MOZAMBICAN',
  NAMIBIAN = 'NAMIBIAN',
  NAURUAN = 'NAURUAN',
  DUTCH = 'DUTCH',
  NEW_ZEALANDER = 'NEW_ZEALANDER',
  NEPALESE = 'NEPALESE',
  NICARAGUAN = 'NICARAGUAN',
  NIGERIAN = 'NIGERIAN',
  NIGERIEN = 'NIGERIEN',
  NIUEAN = 'NIUEAN',
  NOT_SPECIFIED_NATIONALITY = 'NOT_SPECIFIED_NATIONALITY',
  NORTH_KOREAN = 'NORTH_KOREAN',
  NORWEGIAN = 'NORWEGIAN',
  OMANI = 'OMANI',
  PAKISTANI = 'PAKISTANI',
  PALAUAN = 'PALAUAN',
  PALESTINIAN = 'PALESTINIAN',
  PANAMANIAN = 'PANAMANIAN',
  PAPUA_NEW_GUINEAN = 'PAPUA_NEW_GUINEAN',
  PARAGUAYAN = 'PARAGUAYAN',
  PERUVIAN = 'PERUVIAN',
  POLISH = 'POLISH',
  PORTUGUESE = 'PORTUGUESE',
  PUERTO_RICAN = 'PUERTO_RICAN',
  QATARI = 'QATARI',
  RWANDAN = 'RWANDAN',
  ROMANIAN = 'ROMANIAN',
  RUSSIAN = 'RUSSIAN',
  SAHRAWI = 'SAHRAWI',
  SOLOMON_ISLANDER = 'SOLOMON_ISLANDER',
  SALVADORAN = 'SALVADORAN',
  SAMOAN = 'SAMOAN',
  KITTITIAN_NEVISIAN = 'KITTITIAN_NEVISIAN',
  SAMMARINESE = 'SAMMARINESE',
  SAINT_MARTINER = 'SAINT_MARTINER',
  SAINT_LUCIAN = 'SAINT_LUCIAN',
  SAO_TOMEAN = 'SAO_TOMEAN',
  SAINT_VINCENTIAN = 'SAINT_VINCENTIAN',
  SAUDI = 'SAUDI',
  SENEGALESE = 'SENEGALESE',
  SERBIAN = 'SERBIAN',
  SEYCHELLOIS = 'SEYCHELLOIS',
  SIERRA_LEONEAN = 'SIERRA_LEONEAN',
  SINGAPOREAN = 'SINGAPOREAN',
  SYRIAN = 'SYRIAN',
  SOMALI = 'SOMALI',
  SWAZI = 'SWAZI',
  SOUTH_AFRICAN = 'SOUTH_AFRICAN',
  SUDANESE = 'SUDANESE',
  SWEDISH = 'SWEDISH',
  SWISS = 'SWISS',
  SOUTH_KOREAN = 'SOUTH_KOREAN',
  SURINAMESE = 'SURINAMESE',
  SOUTH_SUDANESE = 'SOUTH_SUDANESE',
  THAI = 'THAI',
  TAIWANESE = 'TAIWANESE',
  TANZANIAN = 'TANZANIAN',
  TAJIK = 'TAJIK',
  TIMORESE = 'TIMORESE',
  TOGOLESE = 'TOGOLESE',
  TONGAN = 'TONGAN',
  TRINIDADIAN_TOBAGONIAN = 'TRINIDADIAN_TOBAGONIAN',
  TUNISIAN = 'TUNISIAN',
  TURKISH = 'TURKISH',
  TURKMEN = 'TURKMEN',
  TUVALUAN = 'TUVALUAN',
  UKRAINIAN = 'UKRAINIAN',
  UGANDAN = 'UGANDAN',
  URUGUAYAN = 'URUGUAYAN',
  UZBEK = 'UZBEK',
  VANUATUAN = 'VANUATUAN',
  VATICAN = 'VATICAN',
  VENEZUELAN = 'VENEZUELAN',
  VIETNAMESE = 'VIETNAMESE',
  YEMENI = 'YEMENI',
  DJIBOUTIAN = 'DJIBOUTIAN',
  ZAMBIAN = 'ZAMBIAN',
  ZIMBABWEAN = 'ZIMBABWEAN'
}

export const NATIONALITIES = Object.values(ENationality);

export enum EProvinceExtension {
  OTHER_COUNTRIES = 'OTHER_COUNTRIES'
}

export type TProvinceExtended = EProvince | EProvinceExtension;

export const PROVINCES_EXTENDED: TProvinceExtended[] = [
  ...PROVINCES,
  EProvinceExtension.OTHER_COUNTRIES
];

export const STREET_TYPE_NAMES: Record<string, string> = {
  [EStreetType.STREET]: 'Calle',
  [EStreetType.ST_ABBREV]: 'C/',
  [EStreetType.AVENUE]: 'Avenida',
  [EStreetType.PROMENADE]: 'Paseo',
  [EStreetType.SQUARE]: 'Plaza',
  [EStreetType.SMALL_SQUARE]: 'Plazuela',
  [EStreetType.ROAD]: 'Carretera',
  [EStreetType.PATH]: 'Camino',
  [EStreetType.CROSSING]: 'Travesía',
  [EStreetType.RING_ROAD]: 'Ronda',
  [EStreetType.BOULEVARD]: 'Bulevar',
  [EStreetType.ALLEY]: 'Callejón',
  [EStreetType.NARROW_ALLEY]: 'Calleja',
  [EStreetType.PASSAGE]: 'Pasaje',
  [EStreetType.ROUNDABOUT]: 'Glorieta',
  [EStreetType.TRAFFIC_CIRCLE]: 'Rotonda',
  [EStreetType.HIGHWAY]: 'Autovía',
  [EStreetType.DESCENT]: 'Bajada',
  [EStreetType.NEIGHBORHOOD]: 'Barrio',
  [EStreetType.CATTLE_TRACK]: 'Cañada',
  [EStreetType.COLONY]: 'Colonia',
  [EStreetType.STEEP_STREET]: 'Costanilla',
  [EStreetType.SLOPE]: 'Cuesta',
  [EStreetType.STAIRWAY]: 'Escalinata',
  [EStreetType.ESPLANADE]: 'Explanada',
  [EStreetType.GARDEN]: 'Jardín',
  [EStreetType.PARK]: 'Parque',
  [EStreetType.SITE]: 'Partida',
  [EStreetType.PASSAGEWAY]: 'Pasadizo',
  [EStreetType.COURTYARD]: 'Patio',
  [EStreetType.INDUSTRIAL_ESTATE]: 'Polígono',
  [EStreetType.GATE]: 'Portal',
  [EStreetType.BRIDGE]: 'Puente',
  [EStreetType.PORT]: 'Puerto',
  [EStreetType.RAMBLA]: 'Rambla',
  [EStreetType.RAMP]: 'Rampa',
  [EStreetType.RESIDENTIAL]: 'Residencial',
  [EStreetType.RIVER]: 'Ribera',
  [EStreetType.SECTOR]: 'Sector',
  [EStreetType.TRAIL]: 'Senda',
  [EStreetType.ASCENT]: 'Subida',
  [EStreetType.HOUSING_ESTATE]: 'Urbanización',
  [EStreetType.SIDEWALK]: 'Vereda',
  [EStreetType.THOROUGHFARE]: 'Vía',
  [EStreetType.ZONE]: 'Zona'
};

export const PROVINCE_MAP: Record<string, EProvince> = {
  Almería: EProvince.ALMERIA,
  Cádiz: EProvince.CADIZ,
  Córdoba: EProvince.CORDOBA,
  Granada: EProvince.GRANADA,
  Huelva: EProvince.HUELVA,
  Jaén: EProvince.JAEN,
  Málaga: EProvince.MALAGA,
  Sevilla: EProvince.SEVILLA,
  Álava: EProvince.ALAVA,
  Araba: EProvince.ALAVA,
  Guipúzcoa: EProvince.GUIPUZCOA,
  Gipuzkoa: EProvince.GUIPUZCOA,
  Vizcaya: EProvince.VIZCAYA,
  Bizkaia: EProvince.VIZCAYA,
  'Las Palmas': EProvince.LAS_PALMAS,
  'Santa Cruz de Tenerife': EProvince.SANTA_CRUZ_DE_TENERIFE,
  Valencia: EProvince.VALENCIA,
  València: EProvince.VALENCIA,
  Castellón: EProvince.CASTELLON,
  Castelló: EProvince.CASTELLON,
  Alicante: EProvince.ALICANTE,
  Alacant: EProvince.ALICANTE,
  Barcelona: EProvince.BARCELONA,
  Gerona: EProvince.GERONA,
  Girona: EProvince.GERONA,
  Lérida: EProvince.LERIDA,
  Lleida: EProvince.LERIDA,
  Tarragona: EProvince.TARRAGONA,
  Madrid: EProvince.MADRID,
  'Comunidad de Madrid': EProvince.MADRID,
  Huesca: EProvince.HUESCA,
  Teruel: EProvince.TERUEL,
  Zaragoza: EProvince.ZARAGOZA,
  'A Coruña': EProvince.A_CORUNA,
  'La Coruña': EProvince.A_CORUNA,
  Lugo: EProvince.LUGO,
  Ourense: EProvince.OURENSE,
  Orense: EProvince.OURENSE,
  Pontevedra: EProvince.PONTEVEDRA,
  Badajoz: EProvince.BADAJOZ,
  Cáceres: EProvince.CACERES,
  Ávila: EProvince.AVILA,
  Burgos: EProvince.BURGOS,
  León: EProvince.LEON,
  Palencia: EProvince.PALENCIA,
  Salamanca: EProvince.SALAMANCA,
  Segovia: EProvince.SEGOVIA,
  Soria: EProvince.SORIA,
  Valladolid: EProvince.VALLADOLID,
  Zamora: EProvince.ZAMORA,
  Albacete: EProvince.ALBACETE,
  'Ciudad Real': EProvince.CIUDAD_REAL,
  Cuenca: EProvince.CUENCA,
  Guadalajara: EProvince.GUADALAJARA,
  Toledo: EProvince.TOLEDO,
  Asturias: EProvince.ASTURIAS,
  'Principado de Asturias': EProvince.ASTURIAS,
  'Illes Balears': EProvince.BALEARES,
  Baleares: EProvince.BALEARES,
  'Islas Baleares': EProvince.BALEARES,
  Melilla: EProvince.MELILLA,
  'Ciudad Autónoma de Melilla': EProvince.MELILLA,
  Cantabria: EProvince.CANTABRIA,
  'La Rioja': EProvince.LA_RIOJA,
  Murcia: EProvince.MURCIA,
  'Región de Murcia': EProvince.MURCIA,
  Ceuta: EProvince.CEUTA,
  'Ciudad Autónoma de Ceuta': EProvince.CEUTA,
  Navarra: EProvince.NAVARRA,
  'Comunidad Foral de Navarra': EProvince.NAVARRA
};

export const STREET_TYPE_KEYWORDS: Record<string, EStreetType> = {
  calle: EStreetType.STREET,
  c: EStreetType.ST_ABBREV,
  'c/': EStreetType.ST_ABBREV,
  cl: EStreetType.ST_ABBREV,
  avenida: EStreetType.AVENUE,
  av: EStreetType.AVENUE,
  'av.': EStreetType.AVENUE,
  avda: EStreetType.AVENUE,
  paseo: EStreetType.PROMENADE,
  pº: EStreetType.PROMENADE,
  plaza: EStreetType.SQUARE,
  pl: EStreetType.SQUARE,
  plazuela: EStreetType.SMALL_SQUARE,
  carretera: EStreetType.ROAD,
  ctra: EStreetType.ROAD,
  camino: EStreetType.PATH,
  travesía: EStreetType.CROSSING,
  ronda: EStreetType.RING_ROAD,
  boulevard: EStreetType.BOULEVARD,
  bulevar: EStreetType.BOULEVARD,
  callejón: EStreetType.ALLEY,
  calleja: EStreetType.NARROW_ALLEY,
  pasaje: EStreetType.PASSAGE,
  pje: EStreetType.PASSAGE,
  glorieta: EStreetType.ROUNDABOUT,
  rotonda: EStreetType.TRAFFIC_CIRCLE,

  alameda: EStreetType.PROMENADE,
  autopista: EStreetType.HIGHWAY,
  autovía: EStreetType.HIGHWAY,
  bajada: EStreetType.DESCENT,
  barrio: EStreetType.NEIGHBORHOOD,
  barriada: EStreetType.NEIGHBORHOOD,
  cañada: EStreetType.CATTLE_TRACK,
  colonia: EStreetType.COLONY,
  costanilla: EStreetType.STEEP_STREET,
  cuesta: EStreetType.SLOPE,
  escalinata: EStreetType.STAIRWAY,
  explanada: EStreetType.ESPLANADE,
  jardín: EStreetType.GARDEN,
  jardines: EStreetType.GARDEN,
  parque: EStreetType.PARK,
  partida: EStreetType.SITE,
  pasadizo: EStreetType.PASSAGEWAY,
  patio: EStreetType.COURTYARD,
  polígono: EStreetType.INDUSTRIAL_ESTATE,
  portal: EStreetType.GATE,
  puente: EStreetType.BRIDGE,
  puerto: EStreetType.PORT,
  rambla: EStreetType.RAMBLA,
  rampa: EStreetType.RAMP,
  residencial: EStreetType.RESIDENTIAL,
  ribera: EStreetType.RIVER,
  río: EStreetType.RIVER,
  sector: EStreetType.SECTOR,
  senda: EStreetType.TRAIL,
  sendero: EStreetType.TRAIL,
  subida: EStreetType.ASCENT,
  urbanización: EStreetType.HOUSING_ESTATE,
  urb: EStreetType.HOUSING_ESTATE,
  vereda: EStreetType.SIDEWALK,
  vía: EStreetType.THOROUGHFARE,
  zona: EStreetType.ZONE
};

